import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isVisible: boolean
	hasError: boolean
}

export const Placeholder = styled.label<Props>`
	display: block;
	position: absolute;
	pointer-events: none;
	font-size: ${helpers.font.size.base};
	font-weight: normal;
	margin-top: 2px;
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	transition: color 0.2s ease, opacity 0.2s ease;
	color: ${({ hasError, theme }) => {
		if (hasError) {
			return theme.color.danger
		}
		return theme.color.textMuted
	}};
`
